import { Box, Button, CircularProgress } from "@mui/material"
import ManageSubscription from "../components/ManageSubscription"
import ReinstateSubscription from "../components/ReinstateSubscription"
import MessageModal from "../../../components/MessageModal"
import EditIcon from "@mui/icons-material/Edit"
import SaveIcon from "@mui/icons-material/Save"
import DeleteProfile from "../components/DeleteProfile"

export default function ProfileControlsForm({
    editDisabled,
    disabled,
    handleClick,
    handleSubmit,
    handleProfileSubmit,
    userProfileData,
    message,
    setMessage,
}) {
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                alignItems: "center",
                p: 1,
                width: { xs: "100%", sm: "fit-content" },
                justifyContent: { xs: "center", sm: "space-evenly" },
            }}
        >
            {disabled ? (
                <Box sx={{ width: { xs: "100%", sm: "fit-content" } }}>
                    <Button
                        sx={{
                            width: {
                                xs: "100%",
                                sm: "fit-content",
                                // md: "230px",
                            },
                        }}
                        variant="outlined"
                        disabled={editDisabled}
                        onClick={handleClick}
                        startIcon={
                            editDisabled ? (
                                <CircularProgress size={20} />
                            ) : (
                                <EditIcon />
                            )
                        }
                    >
                        EDIT PROFILE
                    </Button>
                </Box>
            ) : (
                <Box sx={{ width: { xs: "100%", sm: "fit-content" } }}>
                    <Button
                        sx={{
                            width: {
                                xs: "100%",
                                md: "170px",
                            },
                        }}
                        variant="outlined"
                        onClick={handleSubmit(handleProfileSubmit)}
                        startIcon={<SaveIcon />}
                    >
                        SAVE PROFILE
                    </Button>
                </Box>
            )}
            {userProfileData?.data?.user?.status !== "canceled" ? (
                <ManageSubscription />
            ) : (
                <ReinstateSubscription />
            )}
            <DeleteProfile />
            {message && (
                <MessageModal message={message} setMessage={setMessage} />
            )}
        </Box>
    )
}
